import clsx from 'clsx';

import { makeStyles, Theme, createStyles } from 'core/atoms/styles';

import {
  PersonIcon,
  RoomFilledIcon,
  ClassIcon,
  GroupIcon,
} from 'core/cells/oas-icons';

import { TimeplanEventProps } from '../timeplan-event.types';

import { IconTextContent } from './icon-text-content';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100%',
      display: 'flex',
      flexWrap: 'nowrap',
      flexDirection: 'column',
    },
    time: {
      width: theme.spacing(9),
      minWidth: theme.spacing(9),
    },
    truncate: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    data: {
      flexGrow: 1,
    },
    title: {
      fontWeight: 'bold',
    },
    mr: {
      marginRight: theme.spacing(1),
    },
    icon: {
      fontSize: theme.spacing(2),
    },
  }),
);

export const ThreeLinesEventContent = (props: TimeplanEventProps) => {
  const classes = useStyles();
  const {
    timeText,
    event,
    showClasses,
    showGroups,
    showTeachers,
    showRooms,
  } = props;

  return event.display === 'background' ? (
    <></>
  ) : (
    <div className={classes.root}>
      <span className={classes.time}>{timeText}</span>
      <span className={clsx(classes.truncate, classes.title)}>
        {event.title ?? ''}
      </span>
      <div className={clsx(classes.truncate, classes.data)}>
        {!!showTeachers && (
          <IconTextContent
            className={classes.mr}
            text={event.extendedProps?.teachers ?? ''}
          >
            <PersonIcon className={classes.icon} />
          </IconTextContent>
        )}
        {!!showRooms && (
          <IconTextContent
            className={classes.mr}
            text={event.extendedProps?.rooms ?? ''}
          >
            <RoomFilledIcon className={classes.icon} />
          </IconTextContent>
        )}
        {!!showClasses && (
          <IconTextContent
            className={classes.mr}
            text={event.extendedProps?.classes ?? ''}
          >
            <ClassIcon className={classes.icon} />
          </IconTextContent>
        )}
        {!!showGroups && (
          <IconTextContent text={event.extendedProps?.groups ?? ''}>
            <GroupIcon className={classes.icon} />
          </IconTextContent>
        )}
      </div>
    </div>
  );
};
